(() => {
  const typography = new CSSStyleSheet();
  typography.replaceSync(`
    :host {
      --forms-base-font-size: var(--font-paragraph--size) !important;
      --forms-heading-font-size: var(--font-h2--size) !important;
      --heading-font-size: var(--font-h2--size) !important;
    }

    :host [data-form-root],
    :host :is([class*="_textBody_"], [class*="_formError_"],
      [class*="_formFileInputButton_"], input, textarea, select, button, label, legend) {
      font-size: var(--font-paragraph--size) !important;
    }

    :host :is([class*="_textBody_"], [class*="_formError_"]) {
      line-height: var(--font-paragraph--line-height) !important;
    }

    :host [class*="_formHeader_"] [class*="_textBody_"] {
      font-size: var(--font-size--md) !important;
    }

    :host :is([class*="_textHeading_"], h1, h2, h3, h4, h5, h6) {
      font-size: var(--font-h2--size) !important;
      line-height: var(--font-h2--line-height) !important;
    }

    :host [class*="_formDisclaimer_"], :host [class*="_formDisclaimer_"] :is(p, a) {
      font-size: var(--font-size--2xs) !important;
      line-height: var(--font-paragraph--line-height) !important;
    }
  `);

  function styleForms() {
    for (const form of document.querySelectorAll('shopify-forms-embed')) {
      const root = form.shadowRoot;
      if (root && !root.adoptedStyleSheets.includes(typography)) {
        root.adoptedStyleSheets = [...root.adoptedStyleSheets, typography];
      }
    }
  }

  customElements.whenDefined('shopify-forms-embed').then(() => {
    styleForms();
    new MutationObserver(styleForms).observe(document.body, { childList: true, subtree: true });
  });
})();